import React, { PropsWithChildren, useContext } from 'react';
import { useAsyncCallback, UseAsyncReturn } from 'react-async-hook';
import { connectApiAxios } from '../config/axios';
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { ForgotPasswordProps, SignInProps } from "../types/auth-types";

type AuthContextProps = {
  signIn: UseAsyncReturn<any, [SignInProps]>;
  signOut: UseAsyncReturn<any, []>;
  forgotPassword: UseAsyncReturn<any, [ForgotPasswordProps]>;
};

const AuthContext = React.createContext<AuthContextProps>({} as any);

const AuthContextProvider: React.FC<PropsWithChildren<any>> = ( props ) => {
  const { children } = props;
  const navigate = useNavigate();
  const cookies = new Cookies();

  const signIn = useAsyncCallback<any, [SignInProps]>(async ( params: SignInProps ) => {
    const { data } = await connectApiAxios.post(`/api/auth/login`, {
      "email": params.email,
      "password": params.password,
    });
    return data;
  });

  const signOut = useAsyncCallback(async () => {
    localStorage.clear();
    document.cookie = "jwt_authorization=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    cookies.remove('jwt_authorization');
    cookies.remove('companyId');
    navigate('/login');
  });

  const forgotPassword = useAsyncCallback<any, [ForgotPasswordProps]>(async ( params: ForgotPasswordProps ) => {
    await connectApiAxios.post(`/api/auth/reset`, {
      "email": params.email
    });
  });

  return (
    <AuthContext.Provider
      value={{
        signIn,
        signOut,
        forgotPassword,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContextProvider;
